import { authenticatedApi } from "api";

export function lookupCityProvince(country, postal) {
    const params = new URLSearchParams({
        country: country,
        postal_code: postal
    });

    return authenticatedApi.get(`/geo/cities?${params}`);
}

/*
$scope.prefillCityProvince = function()
{
    $scope.updating_city = true;
    city_province = $scope.location.prefillCityProvince($scope.globalScope.install_settings.data.default_country, $scope.globalScope.install_settings.data.default_postal);

    city_province.$promise.then(function(response)
    {
        $scope.updating_city = false;
        if( response.cities.length > 0 ){
            $scope.globalScope.install_settings.data.default_city = response.cities[0].name;
            $scope.globalScope.install_settings.data.default_state = response.cities[0].admin1_name;
        }
    }).catch(function()
    {
        $scope.updating_city = false;
    });
};
*/
